module.exports = __webpack_public_path__ + "img/ball_1_green.38e1a0b5.png";